import { I18n } from '@front/volcanion'

class Callbacks {
  static onSubmitHandler(createVoucher, searchVoucher) {
    return async function onSubmit(values) {
      await createVoucher({ data: _.omit(values, ['repeat']), options: { redirect_repeat: values?.repeat } })
      searchVoucher()
    }
  }

  static getSuccessNotificationHandler() {
    return function getSuccessNotification() {
      return [I18n.t('toast.create.success'), { variant: 'success' }]
    }
  }

  static getFailedNotificationHandler() {
    return function getFailedNotification(err) {
      return [err?.message || I18n.t('error.unknow'), { variant: 'error' }]
    }
  }
}

export default Callbacks
